import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ed2f64b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Under Construction ...", -1))
const _hoisted_2 = { class: "select" }
const _hoisted_3 = ["selected"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { id: "rostertable" }
const _hoisted_9 = { class: "table table-light table-striped" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("col", { style: {"width":"40px"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "thead",
      scope: "col"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      class: "thead",
      scope: "col"
    }, " Starters "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "thead",
      scope: "col"
    }, " Points "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "thead",
      scope: "col"
    }, " PPG ")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead2" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "thead2",
      scope: "col"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      class: "thead2",
      scope: "col"
    }, " Bench "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "thead2",
      scope: "col"
    }, " Points "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "thead2",
      scope: "col"
    }, " PPG ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.owner_selected) = $event)),
        name: "owner",
        id: "owner",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTable()))
      }, [
        _createElementVNode("option", {
          disabled: "",
          selected: _ctx.owner_selected == 'Team:'
        }, "Team:", 8, _hoisted_3),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownerdata, (owner) => {
          return (_openBlock(), _createElementBlock("option", {
            value: owner.select,
            key: owner.select
          }, _toDisplayString(owner.select), 9, _hoisted_4))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.owner_selected]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stats_selected) = $event)),
        name: "stats",
        id: "stats"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statsdata, (stats) => {
          return (_openBlock(), _createElementBlock("option", {
            value: stats.select,
            key: stats.select
          }, _toDisplayString(stats.select), 9, _hoisted_5))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.stats_selected]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.option_selected) = $event)),
        name: "option",
        id: "option"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optiondata, (options) => {
          return (_openBlock(), _createElementBlock("option", {
            value: options.select,
            key: options.select
          }, _toDisplayString(options.select), 9, _hoisted_6))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.option_selected]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modes_selected) = $event)),
        name: "modes",
        id: "modes"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modesdata, (modes) => {
          return (_openBlock(), _createElementBlock("option", {
            value: modes.select,
            key: modes.select
          }, _toDisplayString(modes.select), 9, _hoisted_7))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.modes_selected]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.slice(0,9), (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.position
            }, [
              _createElementVNode("td", null, _toDisplayString(row.position), 1),
              _createElementVNode("td", null, _toDisplayString(row.player), 1),
              _createElementVNode("td", null, _toDisplayString(row.points), 1),
              _createElementVNode("td", null, _toDisplayString(row.ppg), 1)
            ]))
          }), 128))
        ]),
        _hoisted_12,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.slice(9), (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.position
            }, [
              _createElementVNode("td", null, _toDisplayString(row.position), 1),
              _createElementVNode("td", null, _toDisplayString(row.player), 1),
              _createElementVNode("td", null, _toDisplayString(row.points), 1),
              _createElementVNode("td", null, _toDisplayString(row.ppg), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}